import React from 'react';

const Checkmark = () => {
  return(
    <svg width="12px" height="9px" viewBox="0 0 12 9" version="1.1">
      <g transform="translate(0, 0)">
        <path d="M3.71703098,8.38292402 L0.117000975,4.78289402 C-0.039000325,4.62689272 -0.039000325,4.37369061 0.117000975,4.21728931 C0.273402278,4.06088801 0.526604388,4.06088801 0.682605688,4.21728931 L3.99983333,7.53451695 L11.3170943,0.217255976 C11.4734956,0.0608546727 11.7266977,0.0608546727 11.882699,0.217255976 C12.0391003,0.373657279 12.0391003,0.626859389 11.882699,0.782860689 L7.15575885,5.50980086 C6.19805113,6.46750858 4.28263569,8.38292402 4.28263569,8.38292402 C4.20463504,8.46092467 4.10223419,8.500125 3.99983333,8.500125 C3.89783248,8.500125 3.79543163,8.46092467 3.71703098,8.38292402 Z" fill="#00DC86"></path>
      </g>
    </svg>
  )
};

export default Checkmark;
